// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Mze0","left":"styles_left__1lpl4","right":"styles_right__2lGfi","alert":"styles_alert__24ZJ8"};